import React, { useEffect, useState } from 'react'
import Papa from 'papaparse'

const csvURL = 'https://anandstaticstagingcountrycoderequest.s3.ap-south-1.amazonaws.com/digiadglobal-anylatics/data-behaviors1.csv' // Replace with actual CSV URL

const Insights = () => {
  const [data, setData] = useState([])
  const [activeTab, setActiveTab] = useState('content')

  useEffect(() => {
  fetch(csvURL)
    .then((res) => res.text())
    .then((text) => {
      Papa.parse(text, {
        header: true,
        skipEmptyLines: true,
        transformHeader: header => header.trim(), // Normalizes headers
        complete: (results) => {
          console.log('Parsed CSV sample:', results.data[0]) // Debug
          setData(results.data)
        },
      })
    })
}, [])

  return (
    <div className="p-6 bg-white rounded shadow">
      <h2 className="text-2xl font-semibold mb-4 text-gray-800">Behaviors</h2>

      {/* Tabs */}
      <div className="flex border-b mb-4">
        <button
          className={`px-6 py-2 border-b-2 font-medium ${
            activeTab === 'content'
              ? 'border-black text-black'
              : 'border-transparent text-gray-500'
          }`}
          onClick={() => setActiveTab('content')}
        >
          Content Signals
        </button>
        <button
          className={`px-6 py-2 border-b-2 font-medium ${
            activeTab === 'manage'
              ? 'border-black text-black'
              : 'border-transparent text-gray-500'
          }`}
          onClick={() => setActiveTab('manage')}
        >
          Manage Signals
        </button>
      </div>

      {/* Table */}
      {activeTab === 'content' && (
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border">
            <thead>
              <tr className="bg-gray-50 text-left text-sm font-semibold text-gray-600">
                <th className="px-4 py-2 border-b">S. No.</th>
                <th className="px-4 py-2 border-b">Name</th>
                <th className="px-4 py-2 border-b">Uniques</th>
                <th className="px-4 py-2 border-b">Pageviews</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, index) => (
                <tr key={index} className="text-sm text-gray-700 hover:bg-gray-50">
                  <td className="px-4 py-2 border-b">{row['S. No.']}</td>
                  <td className="px-4 py-2 border-b">{row['ISP Name']}</td>
                  <td className="px-4 py-2 border-b">{row['Uniques']}</td>
                  <td className="px-4 py-2 border-b">{row['Pageviews']}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {activeTab === 'manage' && (
        <div className="text-gray-500 text-sm p-4">
          <p>Manage Signals tab content goes here...</p>
          <div className="overflow-x-auto">
          <table className="min-w-full bg-white border">
            <thead>
              <tr className="bg-gray-50 text-left text-sm font-semibold text-gray-600">
                <th className="px-4 py-2 border-b">S. No.</th>
                <th className="px-4 py-2 border-b">Name</th>
                <th className="px-4 py-2 border-b">Uniques</th>
                <th className="px-4 py-2 border-b">Pageviews</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, index) => (
                <tr key={index} className="text-sm text-gray-700 hover:bg-gray-50">
                  <td className="px-4 py-2 border-b">{row['S. No.']}</td>
                  <td className="px-4 py-2 border-b">{row['ISP Name']}</td>
                  <td className="px-4 py-2 border-b">{row['Uniques']}</td>
                  <td className="px-4 py-2 border-b">{row['Pageviews']}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        </div>
      )}
    </div>
  )
}

export default Insights
